import { queryOptions } from '@tanstack/react-query';
import { api } from '@/api';
import type { KnowledgeBase } from '@/features/knowledge-base/types';

export const ORGANIZATION_KNOWLEDGE_BASES_QUERY_KEY = 'organizationKnowledgeBases';

export const organizationKnowledgeBasesQuery = (organizationId: string) =>
  queryOptions({
    queryKey: [ORGANIZATION_KNOWLEDGE_BASES_QUERY_KEY, organizationId],
    queryFn: async () => {
      if (!organizationId) return [] as KnowledgeBase[];
      return (await api.get<KnowledgeBase[]>('v1/internal-kb', { params: { organizationId } }))
        .data;
    },
  });
